import script from "./Register.vue?vue&type=script&setup=true&lang=ts"
export * from "./Register.vue?vue&type=script&setup=true&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=14c489a7&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14c489a7"]])

export default __exports__